import { useMemo, type ReactElement } from 'react';
import { usePageBreadcrumb, usePageSidebar } from '@/hooks';
import { sidebarItems } from './sidebar';
import { PortalEmpleoInfo, SectionIntro, SectionTitle, JobOfferList } from '@/components';

export const PortalEmpleo = (): ReactElement => {
	usePageBreadcrumb([{ label: 'Servicios' }, { label: 'Portal de empleo' }]);

	const sidebar = useMemo(() => sidebarItems, []);
	usePageSidebar(sidebar, true);

	return (
		<div>
			<SectionTitle title="Portal de empleo" tag="h1" align="left" className="u-mb-16" />
			<SectionIntro text="A través del Portal de Empleo el Colegio Notarial de Madrid presta a sus colegiados un servicio de intermediación en la búsqueda de empleados para sus notarías. Los colegiados interesados en el servicio pueden enviar sus ofertas de empleo por correo electrónico y los candidatos que lo deseen pueden inscribirse en las ofertas vigentes publicadas en el Portal que sean de su interés. El Portal de Empleo únicamente intermedia entre el candidato y el notario sin realizar labores de selección." />
			<PortalEmpleoInfo />
			<JobOfferList />
		</div>
	);
};
